import { render, staticRenderFns } from "./Creators.vue?vue&type=template&id=70df17f1&scoped=true&"
import script from "./Creators.vue?vue&type=script&lang=js&"
export * from "./Creators.vue?vue&type=script&lang=js&"
import style0 from "./Creators.vue?vue&type=style&index=0&id=70df17f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70df17f1",
  null
  
)

export default component.exports